import React from "react";
import {
  defineBlock,
  smartProps,
  useSmartProp,
  useInspectorControl,
  useEditor,
} from "@smartfire/gutenberg-react";
import style from "./block.module.scss";
import { PanelBody, PanelRow, TextControl } from "@wordpress/components";
import { ReactComponent as BouteilleIcon } from "./scan-vert.svg";
import Button from "../shared/button-icon";
import EditableText from "../shared/editable-text";
import { ReactComponent as IconBouton } from "../assets/bouteilleIcon.svg";

function Inspector() {
  const [valider, setValider] = useSmartProp("valider");
  const [formUrl, setFormUrl] = useSmartProp("formUrl");
  const [urlButton, setUrlButton] = useSmartProp("urlButton");

  return (
    <>
      <PanelBody title="Configuration verification token" initialOpen={true}>
        <PanelRow>
          <TextControl
            label={"Texte Bouton Valider"}
            value={valider}
            onChange={(value) => setValider(value)}
          />
        </PanelRow>
        <PanelRow>
          <TextControl
            label={"Lien page vérification"}
            value={formUrl}
            onChange={(value) => setFormUrl(value)}
          />
        </PanelRow>
      </PanelBody>
      <PanelBody title="Configuration bouton Bottom" initialOpen={true}>
        <PanelRow>
          <TextControl
            label={"Lien bouton"}
            value={urlButton}
            onChange={(value) => setUrlButton(value)}
          />
        </PanelRow>
      </PanelBody>
    </>
  );
}

function Block({ formUrl, valider, urlButton }) {
  useInspectorControl(Inspector);
  const { isEditing } = useEditor();
  return (
    <div className={style.block}>
      <div className={style.top}>
        <div className={style.content}>
          <div className={style.left}>
            <BouteilleIcon />
            <div>
              <EditableText
                tagName="h3"
                className={style.title}
                smartProp="title"
                placeholder={"Entrez un titre"}
              />
              <EditableText
                className={style.text}
                smartProp="text"
                placeholder={"Entrez un texte"}
              />
            </div>
          </div>
          <div className={style.right}>
            <form method="get" action={formUrl}>
              <input type="text" name="tokenVector" placeholder="XXX-XXX-XXX" />
              <input type="submit" value={valider} />
            </form>
          </div>
        </div>
      </div>
      <div className={style.bottom}>
        <div className={style.content}>
          <EditableText
            className={style.text}
            smartProp="textBottom"
            placeholder={"Entrez un texte"}
          />
          <Button
            classIcon={style.icon}
            Icon={IconBouton}
            href={urlButton && urlButton}
            className={style.button}
            disabled={isEditing && true}
          >
            <EditableText
              tagName="span"
              smartProp="textButton"
              placeholder={"Entrez un texte"}
            />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    text: smartProps.string.withDefault(""),
    title: smartProps.string.withDefault(""),
    formUrl: smartProps.string.withDefault(""),
    valider: smartProps.string.withDefault("Vérifiez"),
    textBottom: smartProps.string.withDefault(""),
    textButton: smartProps.string.withDefault("Authenticité et protection"),
    urlButton: smartProps.string.withDefault(""),
  },
  setup: {
    title: "Home Check Bouteille",
  },
});
